import dayjs from "dayjs";
import React from "react";
import { AuthData } from "../../Components/Global";
import {
  SectionSalesMonthGrowth,
  SectionSalesYTD,
  SectionSPTestingCost,
  SectionSPTestingCostBySalesCode,
  SectionTopYearSales,
} from "./sectionTable";
import SectionSPTestingCostByDepartment from "./sectionTable/SectionSPTestingCostByDepartment";
import SectionSPTestingCostByLabSubCount from "./sectionTable/SectionSPTestingCostByLabSubCount";
import HeaderTitle from "../../Components/HeaderTitle";

const Analytic = () => {
  const userData = AuthData();
  const defaultStartDate = dayjs().startOf("year");

  const columnsCustomer = [
    { title: "AccountId", dataIndex: "AccountId", key: "AccountId" },
    { title: "CustomerId", dataIndex: "CustomerId", key: "CustomerId" },
    { title: "CustomerName", dataIndex: "CustomerName", key: "CustomerName" },
    {
      title: "ContactPerson",
      dataIndex: "ContactPerson",
      key: "ContactPerson",
    },
    { title: "Address", dataIndex: "Address", key: "Address" },
    { title: "EmailContact", dataIndex: "EmailContact", key: "EmailContact" },
    { title: "Phone", dataIndex: "Phone", key: "Phone" },
    { title: "MobilePhone", dataIndex: "MobilePhone", key: "MobilePhone" },
    { title: "Fax", dataIndex: "Fax", key: "Fax" },
  ];

  const columnsSales = [
    { title: "AccountId", dataIndex: "AccountId", key: "AccountId" },
    { title: "SalesCode", dataIndex: "SalesCode", key: "SalesCode" },
    { title: "SalesName", dataIndex: "SalesName", key: "SalesName" },
    { title: "SalesNumber", dataIndex: "SalesNumber", key: "SalesNumber" },
    { title: "Team", dataIndex: "Team", key: "Team" },
    { title: "Email", dataIndex: "Email", key: "Email" },
    { title: "Mobile", dataIndex: "Mobile", key: "Mobile" },
    { title: "Phone", dataIndex: "Phone", key: "Phone" },
    { title: "IsSuspend", dataIndex: "IsSuspend", key: "IsSuspend" },
    { title: "UserCreated", dataIndex: "UserCreated", key: "UserCreated" },
  ];

  return (
    <>

      <div className="mb-4">
        <HeaderTitle title="Analytic" subtitle="Advanced Analytics for System Data" />
      </div>

      {/* <div className="bg-white p-4 rounded-md mb-4">
        <h1 className="text-xl font-medium border-b-2 mb-4 pb-2">Analytic</h1>
      </div> */}

      {/* Section 1: SALES MONTH GROWTH */}
      {userData.Role === "Admin" && (
        <SectionSalesMonthGrowth
          userData={userData}
          columnsCustomer={columnsCustomer}
          defaultStartDate={defaultStartDate}
        />
      )}

      {/* Section 2: SALES YTD */}
      {userData.Role === "Admin" && (
        <SectionSalesYTD
          userData={userData}
          columnsCustomer={columnsCustomer}
          defaultStartDate={defaultStartDate}
        />
      )}

      {/* Section 3: TOP YEAR SALES */}
      {userData.Role === "Admin" && (
        <SectionTopYearSales
          userData={userData}
          columnsCustomer={columnsCustomer}
          defaultStartDate={defaultStartDate}
        />
      )}

      {/* Section 4: SP TESTING COST */}
      <SectionSPTestingCost
        userData={userData}
        columnsCustomer={columnsCustomer}
        defaultStartDate={defaultStartDate}
      />

      {/* Section 5: SP TESTING COST BY SALES CODE */}
      {userData.Role === "Admin" && (
        <SectionSPTestingCostBySalesCode
          userData={userData}
          columnsCustomer={columnsCustomer}
          defaultStartDate={defaultStartDate}
          columnsSales={columnsSales}
        />
      )}

      {/* Section 6: SP TESTING COST BY DEPARTMENT */}
      {userData.Role === "Admin" && (
        <SectionSPTestingCostByDepartment
          userData={userData}
          columnsCustomer={columnsCustomer}
          defaultStartDate={defaultStartDate}
        />
      )}

      {/* Section 7: SP TESTING COST BY LABSUBCOUNT */}
      {userData.Role === "Admin" && (
        <SectionSPTestingCostByLabSubCount
          userData={userData}
          columnsCustomer={columnsCustomer}
          defaultStartDate={defaultStartDate}
        />
      )}
    </>
  );
};

export default Analytic;
